module.exports = __webpack_public_path__ + "img/sheep_des_1.5e24b16b.jpg";